import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import AccountingSidebar from "../components/AccountingSidebar";
import InactiveShipmentAlertModal from "../components/InactiveShipmentAlertModal";
import "../components/Sidebar.css";

const AccountingLayout = () => {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const getMobileTitle = () => {
    if (location.pathname.includes("/accounting/requests/create")) return "Request Creation";
    if (location.pathname.includes("/accounting/requests")) return "Request Summary";
    if (location.pathname.includes("/accounting/liquidation-user127-approvals")) return "Liquidation Approval";
    if (location.pathname.includes("/accounting/liquidation-approvals")) return "Leader Approval";
    if (location.pathname.includes("/accounting/liquidation")) return "Liquidation Workflow";
    if (location.pathname.includes("/accounting/cost-analysis-user127-approvals")) return "Cost Analysis Final Approval";
    if (location.pathname.includes("/accounting/cost-analysis-templates")) return "Cost Analysis Templates";
    if (location.pathname.includes("/accounting/cost-analysis-initial-approvals")) return "Cost Analysis Initial Approval";
    if (location.pathname.includes("/accounting/cost-analysis-approvals")) return "Cost Analysis Initial Approval";
    if (location.pathname.includes("/accounting/cost-analysis")) return "Cost Analysis";
    if (location.pathname.includes("/accounting/vendors")) return "Vendor Enlistment";
    if (location.pathname.includes("/accounting/customers")) return "Customer Enlistment";
    if (location.pathname.includes("/accounting/particulars")) return "Particulars";
    if (location.pathname.includes("/accounting/chart-accounts")) return "Chart of Accounts";
    if (location.pathname.includes("/accounting/production-report")) return "Production Report";
    if (location.pathname.includes("/accounting/jo-ledger")) return "JO Ledger";
    if (location.pathname.includes("/accounting/jo-requests")) return "JO Requests";
    if (location.pathname.includes("/accounting/profile")) return "My Profile";
    return "Accounting";
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  return (
    <div className="min-h-screen w-full bg-gray-100">
      <header className="sticky top-0 z-40 flex items-center justify-between gap-3 border-b border-white/10 bg-blue px-4 py-3 text-white shadow-lg lg:hidden">
        <button
          type="button"
          onClick={() => setMobileMenuOpen(true)}
          className="flex h-10 w-10 items-center justify-center rounded-2xl bg-white/10 text-white transition hover:bg-white/20"
          aria-label="Open menu"
        >
          <i className="fa-solid fa-bars text-lg" />
        </button>
        <div className="min-w-0 text-center">
          <p className="text-[10px] font-semibold uppercase tracking-[0.18em] text-white/70">
            Accounting Portal
          </p>
          <p className="truncate text-sm font-bold">{getMobileTitle()}</p>
        </div>
        <div className="h-10 w-10" />
      </header>

      <aside className="fixed inset-y-0 left-0 z-30 hidden w-72 overflow-y-scroll sidebar-scrollable lg:block">
        <AccountingSidebar />
      </aside>

      {mobileMenuOpen && (
        <div className="fixed inset-0 z-50 lg:hidden">
          <button
            type="button"
            className="absolute inset-0 bg-black/40 backdrop-blur-[1px]"
            aria-label="Close menu"
            onClick={() => setMobileMenuOpen(false)}
          />
          <aside className="absolute inset-y-0 left-0 w-72 overflow-y-scroll sidebar-scrollable shadow-2xl">
            <AccountingSidebar forceExpanded />
          </aside>
        </div>
      )}

      <div className="min-h-screen w-full lg:pl-72">
        <main className="w-full min-w-0 bg-gray-100">
          <div className="w-full px-4 py-4 sm:px-5 lg:px-6 lg:py-6">
            <Outlet />
          </div>
        </main>
      </div>
      <InactiveShipmentAlertModal />
    </div>
  );
};

export default AccountingLayout;
